import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import React, { useEffect, useState } from "react";
import { components as selectComponents } from "react-select";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { categoryListApi } from "services/category";
import "./subCatManagement.scss";
import { CommonSelect, Input } from "common/InputForm";

import { ImageInput, ImagePreview } from "utils/imagePreviewURLConverter";
import useFullPageLoader from "common/UseFullPageLoader";
import { FaSearch } from "react-icons/fa";

import {
  addSubCategoryApi,
  subCategoryListApiDetail,
  subCategoryMasterApi,
  subCategoryUpdateApiDetail,
} from "services/subCategory";
import { IoChevronBack } from "react-icons/io5";
import { toastMessage } from "utils/toastMessage";

const SeasonalIllnessSearchControl = ({ children, ...props }) => (
  <selectComponents.Control {...props}>
    <FaSearch className="seasonal-illness-search-icon" />
    {children}
  </selectComponents.Control>
);

const EditSubCat = ({
  selectedSubCatIdState,
  setFetchedSubCatData,
  closeModel,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();

  // ⭐ id comes from the route param, e.g. path="/sub-Category-Management/Edit-sub-Category/:id"
  const { id } = useParams();
  const Navigate = useNavigate();

  //   -------assign category data
  const [fetchedCatData, setFetchedCatData] = useState([]);
  const [seasonalFetchedCatData, setSeasonalFetchedCatData] = useState([]);
  const [subCatMaster, setSubCatMaster] = useState([]);

  // --------Having received img link from CLOUD here it is holding it

  const [imgInputState, setImageInputState] = useState("");
  const [imgPreviewState, setImgPreviewState] = useState(null);
  const [selectedImageName, setSelectedImageName] = useState("");

  // -----------coupon code applicable or not state

  const [isCouponCodeApplicable, setIsCouponCodeApplicable] = useState(false);

  const [subCatNameState, setSubCatNameState] = useState("");

  const [categoryState, setCategoryState] = useState("");
  // ----------will store multi selected options
  const [multiSelectOptions, setMultiSelectOptions] = useState([]);

  // -------Essential
  const [typesToComponent, setTypesToComponent] = useState([]);

  const formatImageFileName = (fileName) =>
    decodeURIComponent(fileName || "").replace(/^\d+-/, "");

  const getFileNameFromUrl = (url) => {
    if (!url) return "";

    try {
      const { pathname } = new URL(url);
      return formatImageFileName(pathname.split("/").pop());
    } catch (error) {
      return formatImageFileName(url.split("?")[0].split("/").pop());
    }
  };

  const catDataFetchApiCall = async () => {
    try {
      onShow();

      // Dropdown needs the full list, not just the API's default first page.
      const query = {
        type: "CATEGORY",
        limit: 1000,
      };
      const {
        data: {
          data: { total, categories },
        },
        status,
        message,
      } = await categoryListApi(query);

      if (status === 200) {
        setFetchedCatData(categories);
      }
    } catch (error) {
      console.log("Cat Data fetch error:---> ", error);
    } finally {
      onHide();
    }
  };

  const seasonalIllnessDataFetchApiCall = async () => {
    try {
      onShow();

      const query = {
        type: "SEASONALILLNESS",
        limit: 1000,
      };
      const {
        data: {
          data: { total, categories },
        },
        status,
        message,
      } = await categoryListApi(query);

      if (status === 200) {
        setSeasonalFetchedCatData(categories);
      }
    } catch (error) {
      console.log("Cat Data fetch error:---> ", error);
    } finally {
      onHide();
    }
  };

  const fetchSubCategoryMasterData = async () => {
    try {
      const query = { type: "SUBCATEGORY" };

      const {
        data: { status, code, data },
      } = await subCategoryMasterApi(query);
      if (status || code === 200) {
        setSubCatMaster(data);
      }
    } catch (error) {
      console.log("subCategoryMasterApi: error", error);
    }
  };

  const fetchSelectedSubCategoryDetail = async () => {
    try {
      // ⭐ id from the route param
      const dataResponse = await subCategoryListApiDetail(id);

      const status = dataResponse?.data?.status;
      const code = dataResponse?.data?.code;
      const data = dataResponse?.data?.data;

      if (status || code === 200) {
        setImgPreviewState(data?.image);
        setSelectedImageName(getFileNameFromUrl(data?.image));
        setIsCouponCodeApplicable(data?.isCouponApplicable);
        setSubCatNameState(data?.name);
        setCategoryState(data?.category?._id);
        setTypesToComponent(data?.collection.map((pro) => pro._id));
        setMultiSelectOptions(
          data?.seasonalIllness.map((mapProp) => {
            return {
              value: mapProp._id,
              label: mapProp.name,
            };
          }),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    catDataFetchApiCall();
    seasonalIllnessDataFetchApiCall();
    fetchSubCategoryMasterData();
    // ⭐ only fetch detail once we actually have an id from the route
    if (id) {
      fetchSelectedSubCategoryDetail();
    }
  }, [id]);

  // ----------------error state
  const [error, setError] = useState({});

  const imgUploadFunction = async (e) => {
    const selectedFile = e?.target?.files?.[0];

    if (!selectedFile) {
      return;
    }

    // ---------img preview state set
    if (!selectedFile?.type.includes("image/")) {
      setError((stateProp) => ({
        ...stateProp,
        imgErrorOccur: "Please Choose Image file not others",
      }));
    } else {
      try {
        setSelectedImageName(formatImageFileName(selectedFile.name));
        const data = await imgUploadToCloudFun(selectedFile);
        if (data?.status === 200) {
          setImageInputState(data?.data[0]);
          setImgPreviewState(selectedFile);
        }
      } catch (error) {
        console.log("error while uploading and getting data", error);
      }
    }
  };

  const clearStateFun = () => {
    setIsCouponCodeApplicable(false);
    setSubCatNameState("");
    setCategoryState("");
    setMultiSelectOptions([]);
    setTypesToComponent([]);
    setImageInputState("");
    setSelectedImageName("");
    setImgPreviewState(null);
    setError({});

    // ⭐ optional now — EditSubCat is a routed page, so a parent isn't
    // always passing closeModel down as a prop
    if (typeof closeModel === "function") {
      closeModel();
    }
  };

  const validate = () => {
    let canSubmit = true;
    let tempError = {};

    if (subCatNameState === "" || subCatNameState.length === 0) {
      canSubmit = false;
      tempError.subCatNameInput = "Required Field";
    }

    if (categoryState === "" || categoryState.length === 0) {
      canSubmit = false;
      tempError.subCatStateSelect = "Required Field";
    }

    setError(tempError);
    return canSubmit;
  };

  const doSubmitFunction = async () => {
    if (validate()) {
      try {
        const data = {
          name: subCatNameState,
          category: categoryState,
          isCouponApplicable: isCouponCodeApplicable,
          seasonalIllness: multiSelectOptions.map((mapProp) => mapProp.value),
          collection: typesToComponent || [],
        };

        imgInputState.length === 0
          ? (() => null)()
          : (data.image = imgInputState);

        const {
          data: { code, status, message },
        } = await subCategoryUpdateApiDetail({
          data,
          id,
        });

        if (code === 200 || status) {
          // ⭐ toast + navigate fire first and unconditionally, so nothing
          // below (missing props on a routed page) can silently swallow them
          toastMessage(
            message || "Sub Category updated successfully.",
            "success",
          );
          Navigate("/sub-Category-Management");

          // ⭐ optional — only call if a parent actually passed these props
          if (typeof setFetchedSubCatData === "function") {
            setFetchedSubCatData();
          }
          clearStateFun();
        }
      } catch (error) {
        console.log("Sub Cat add error:---> ", error);

        toastMessage(
          error?.response?.data?.message ||
            "Failed to update Sub Category.",
          "error",
        );
      }
    }
  };

  const categoryOptions = fetchedCatData.map((item) => ({
    value: item._id,
    label: item.name,
  }));
  const selectedCategoryOption =
    categoryOptions.find((item) => item.value === categoryState) || null;

  return (
    <div className="add-cat-parent-container">
      <div className="link-header-holder">
        <p>
          <Link to={-1}>
            <IoChevronBack />
            Back
          </Link>
          <span>Product-Management</span>
          &nbsp;
          <span>/ Edit Sub Category </span>
        </p>
      </div>
      <div>
        <h3 style={{ color: "black" }}>Edit Sub Category</h3>
      </div>

      <div className="card">
        <div className="add-cat-container">
          <div className="left-side">
            <div>
              <p>
                <b>Select Image (56px × 156px)</b>
              </p>
              <div className="file-input-display form-control">
                <label htmlFor="sub-category-image-input">Choose file</label>
                <span title={selectedImageName || "No file chosen"}>
                  {selectedImageName || "No file chosen"}
                </span>
                <input
                  id="sub-category-image-input"
                  onChange={imgUploadFunction}
                  type="file"
                  accept="image/*"
                />
              </div>
              {error.cloudImgInstance && (
                <p className="errorMsg">{error.cloudImgInstance}</p>
              )}
            </div>

            {/* ------img preview */}
            <div>
              <ImagePreview file={imgPreviewState} />
            </div>

            {/* -----coupon code applicable or not ?--- */}
            <div className="coupon-code-permission-container">
              <label htmlFor="Coupon-code-id">
                Coupon code Applicable{" "}
                <input
                  id="Coupon-code-id"
                  type="checkbox"
                  checked={isCouponCodeApplicable}
                  value={isCouponCodeApplicable}
                  name="Coupon-code"
                  onChange={(e) => {
                    setIsCouponCodeApplicable(!isCouponCodeApplicable);
                  }}
                />
              </label>
            </div>
          </div>
          <div className="right-side">
            <div>
              <Input
                type="text"
                label="Sub-Category Name"
                placeholder="Sub-Category Name..."
                name="subCatName"
                maxLength={50}
                value={subCatNameState}
                onChange={(e) => {
                  setSubCatNameState(e.target.value);
                }}
              />

              {error.subCatNameInput && (
                <p className="errorMsg">{error.subCatNameInput}</p>
              )}
            </div>

            {/* -----category-assign */}

            {fetchedCatData.length && (
              <div className="form_field">
                <CommonSelect
                  className="assign-category-search-select"
                  label={"Assign Category"}
                  onChange={(selectedOption) =>
                    setCategoryState(selectedOption?.value || "")
                  }
                  value={selectedCategoryOption}
                  options={categoryOptions}
                  placeholder="Search Category..."
                  isSearchable={true}
                />

                {error.subCatStateSelect && (
                  <p className="errorMsg">{error.subCatStateSelect}</p>
                )}
              </div>
            )}

            {/* ---seasonal illness */}

            {seasonalFetchedCatData.length && (
              <div>
                <CommonSelect
                  className="seasonal-illness-search-select"
                  value={multiSelectOptions || []}
                  label="Seasonal Illness (Optional)"
                  name="selectSeasonalIllness"
                  isMulti={true}
                  onChange={(commonSelectData) => {
                    setMultiSelectOptions(commonSelectData);
                  }}
                  options={seasonalFetchedCatData.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                  isSearchable={true}
                  components={{
                    Control: SeasonalIllnessSearchControl,
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
            )}

            {/* -----------Essentials */}

            {subCatMaster.length && (
              <div className="all-essentials">
                <SubCatTypeComponent
                  setTypesToComponent={setTypesToComponent}
                  subCatMasterData={subCatMaster}
                  typesToComponent={typesToComponent}
                />
              </div>
            )}
          </div>
        </div>

        {/* ---------submit button */}
        <div className="submit-button-holder">
          <button type="button" className="button" onClick={doSubmitFunction}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditSubCat;

const SubCatTypeComponent = ({
  setTypesToComponent,
  subCatMasterData,
  typesToComponent,
}) => {
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    if (checked) {
      setTypesToComponent((prev) => [...prev, value]);
    } else {
      setTypesToComponent((prev) => prev.filter((item) => item !== value));
    }
  };

  return (
    <div className="summers-container">
      {subCatMasterData.map((mapProp, ind) => (
        <label key={ind}>
          <input
            type="checkbox"
            name="Essentials"
            value={mapProp._id}
            onChange={handleCheckboxChange}
            checked={typesToComponent.includes(mapProp._id) ? true : false}
          />{" "}
          {mapProp?.title}
        </label>
      ))}
      <br />
    </div>
  );
};